import { Organization } from '@mp/kernel/organizations/domain';

export function* filterOrganizationsBySearchTerm(
  organizations: Iterable<Organization>,
  searchTerm: string,
): Iterable<Organization> {
  if (!searchTerm) {
    yield* organizations;
    return;
  }

  searchTerm = searchTerm.toLowerCase();

  for (const o of organizations) {
    if (o.name.toLowerCase().includes(searchTerm) || o.institutionCode?.toLowerCase()?.includes(searchTerm) === true) {
      yield o;
    }
  }
}
